module.exports = __webpack_public_path__ + "images/switch_off_wca_fded58f3e722119157cd29af1471cf3d.svg";